var React = require('react');

function Capsule (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Capsule"),React.createElement("path",{"id":"path1518","className":"cls-1","d":"M74,42.56H54l-20,20v20l10,10,10-10H74l10,10,10-10v-20Z","key":2})]);
}

Capsule.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Capsule;

Capsule.default = Capsule;
